/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://rqxs37254f.execute-api.eu-west-3.amazonaws.com/prod",
            "region": "eu-west-3"
        },
        {
            "name": "db",
            "endpoint": "https://atpnrzv4be.execute-api.eu-west-3.amazonaws.com/prod",
            "region": "eu-west-3"
        },
        {
            "name": "proxy",
            "endpoint": "https://y6cuz47ki7.execute-api.eu-west-3.amazonaws.com/prod",
            "region": "eu-west-3"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-3:1d2ca59c-1f3e-44cb-86d6-bc702d0a78b1",
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_W3iabQ6hy",
    "aws_user_pools_web_client_id": "2gr88glfgmqk9b13jf5nsgr4qp",
    "oauth": {
        "domain": "paperoffice9c9710b8-9c9710b8-prod.auth.eu-west-3.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:8080/,https://staging.d2bi6pr5g5u5zt.amplifyapp.com/,https://prod.d2bi6pr5g5u5zt.amplifyapp.com/,https://staging.paperoffice.ops.papernest.com/,https://paperoffice.ops.papernest.com/,https://dev.d2bi6pr5g5u5zt.amplifyapp.com/,https://dev.paperoffice.ops.papernest.com/",
        "redirectSignOut": "http://localhost:8080/,https://staging.d2bi6pr5g5u5zt.amplifyapp.com/,https://prod.d2bi6pr5g5u5zt.amplifyapp.com/,https://staging.paperoffice.ops.papernest.com/,https://paperoffice.ops.papernest.com/,https://dev.d2bi6pr5g5u5zt.amplifyapp.com/,https://dev.paperoffice.ops.papernest.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-3",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "profiles-prod",
            "region": "eu-west-3"
        }
    ]
};


export default awsmobile;
